import { AccessMatrixModel } from "./access-matrix.model";

export class RoleModel {
  public roleId: number;
  public roleHashId: string;
  public roleName: string;
  public entity: string;
  public isDefault: boolean;
  public roleType: string;
  public accessList: AccessMatrixModel[];
  public isChecked: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role-management/models/role.model.ts